import {CSSProperties, RefObject, useLayoutEffect, useState} from "react";

interface IParams {
    anchorRef: RefObject<HTMLElement | null>;
    isActive: boolean;
    gapPx?: number;
}

const getAnchorPositionStyle = (anchor: HTMLElement, gapPx: number): CSSProperties => {
    const rect = anchor.getBoundingClientRect();

    return {
        position: "fixed",
        top: rect.bottom + gapPx,
        left: rect.left,
        width: rect.width,
        zIndex: 1100
    };
};

export const useAnchoredDropdownPosition = (params: IParams): CSSProperties | undefined => {
    const {anchorRef, isActive, gapPx = 8} = params;
    const [positionStyle, setPositionStyle] = useState<CSSProperties>();

    useLayoutEffect(() => {
        if (!isActive) {
            setPositionStyle(undefined);
            return;
        }

        const updatePosition = () => {
            const anchor = anchorRef.current;

            if (!anchor) {
                return;
            }

            setPositionStyle(getAnchorPositionStyle(anchor, gapPx));
        };

        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);

        return () => {
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [anchorRef, gapPx, isActive]);

    if (!isActive) {
        return undefined;
    }

    return positionStyle ?? (anchorRef.current ? getAnchorPositionStyle(anchorRef.current, gapPx) : undefined);
};
import {CSSProperties, RefObject, useLayoutEffect, useState} from "react";

interface IParams {
    anchorRef: RefObject<HTMLElement | null>;
    isActive: boolean;
    gapPx?: number;
}

const getAnchorPositionStyle = (anchor: HTMLElement, gapPx: number): CSSProperties => {
    const rect = anchor.getBoundingClientRect();

    return {
        position: "fixed",
        top: rect.bottom + gapPx,
        left: rect.left,
        width: rect.width,
        zIndex: 1100
    };
};

export const useAnchoredDropdownPosition = (params: IParams): CSSProperties | undefined => {
    const {anchorRef, isActive, gapPx = 8} = params;
    const [positionStyle, setPositionStyle] = useState<CSSProperties>();

    useLayoutEffect(() => {
        if (!isActive) {
            setPositionStyle(undefined);
            return;
        }

        const updatePosition = () => {
            const anchor = anchorRef.current;

            if (!anchor) {
                return;
            }

            setPositionStyle(getAnchorPositionStyle(anchor, gapPx));
        };

        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);

        return () => {
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [anchorRef, gapPx, isActive]);

    if (!isActive) {
        return undefined;
    }

    return positionStyle ?? (anchorRef.current ? getAnchorPositionStyle(anchorRef.current, gapPx) : undefined);
};
